import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import {
   ControlValueAccessor,
   FormGroupDirective,
   NG_VALUE_ACCESSOR,
   UntypedFormBuilder,
   UntypedFormControl,
   UntypedFormGroup,
   Validators,
} from '@angular/forms';
import { UsStates } from 'src/app/common-components/confirmation-dialog/enumerations/states';
import { StateOptions } from 'src/app/pages/location-details/models/state-options.model';
import { LCS_SINGLE_SELECT_OPTIONS } from '../single-select/single-select-base';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: StateSelectComponent,
        },
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: StateSelectComponent,
        },
    ],
    selector: 'ndt-state-select',
    templateUrl: './state-select.component.html',
    standalone: false
})
export class StateSelectComponent implements ControlValueAccessor, DoCheck {
   @Input() location: any;

   @Input() required: boolean;

   @Input() set isDisabled(disabled: boolean) {
      if (disabled == true) {
         this.stateControl.disable();
      } else {
         this.stateControl.enable();
      }
   }

   @Output() stateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

   states = UsStates.states;

   searchedStateMappings: StateOptions[] = [];

   stateControl = new UntypedFormControl();

   formGroup: UntypedFormGroup;

   private _value: any;

   isValidState: boolean;

   private _onChange: (_: any) => void;

   private _onTouched: () => void;

   constructor(private fb: UntypedFormBuilder, private parentForm: FormGroupDirective) {
      this.formGroup = this.fb.group(
         {
            stateControl: this.stateControl,
         },
         {
            validators: this.required ? [Validators.required] : [],
         }
      );

      this.stateControl.valueChanges.subscribe((newValue) => {
         this.updateValue(newValue);
      });
   }

   onSearch(searchText: string) {
      const lowerCaseSearchText = searchText.toLowerCase();
      this.searchedStateMappings = this.states.filter((x) => {
         const lowerCaseName = x.name.toLowerCase();
         const lowerCaseAbbreviation = x.abbreviation.toLowerCase();

         return lowerCaseName.startsWith(lowerCaseSearchText) || lowerCaseAbbreviation.startsWith(lowerCaseSearchText);
      });
   }

   onSearchReset() {
      this.searchedStateMappings = this.states;
   }

   displayWith(mappingOption: StateOptions) {
      return `${mappingOption ?? ''}`;
   }

   writeValue(value: any): void {
      this._value = value;
   }

   registerOnChange(fn: any): void {
      this._onChange = fn;
   }

   registerOnTouched(fn: any): void {
      this._onTouched = fn;
   }

   updateValue(newValue: any): void {
      if (this._value !== newValue) {
         this._value = newValue;

         if (this._onChange) {
            this._onChange(newValue);
         }

         if (this._onTouched) {
            this._onTouched();
         }

         if (this.stateControl.valid) {
            this.stateChanged.emit(true);
         }
      }
   }

   ngDoCheck(): void {
      if (this.parentForm.form.invalid && (this.parentForm.submitted || this.formGroup.touched)) {
         this.formGroup.markAllAsTouched();
      }
   }
}
